<template>
	<v-layout
		row
		wrap
		class="assign-box"
		pa-4>
		<v-flex
			md12
			text-xs-left>
			<p class="label-medium">Mucamas asignadas</p>
		</v-flex>
		<v-flex
			md12
			text-xs-left
			body-border-bottom>
			<user-selector
				:key="housemaid.id"
				:user="housemaid">
			</user-selector>
		</v-flex>
		<v-flex md12 text-xs-left pt-2>
			<p class="label-medium mb-0">Datos</p>
		</v-flex>
		<v-flex md12 text-xs-left pt-2>
			<list-detail-description :details="details" class="px-2"></list-detail-description>
		</v-flex>
		<v-flex md12 pt-2>
			<table-run
				v-bind:columns="columns"
				v-bind:rows="rows"
				v-bind:include-delete="false"
				v-bind:include-search="false"
				v-bind:include-options="true"
				v-bind:include-export-to-excel="false"
				v-bind:selectable="false"
				v-on:on-sortable-event="columnSortableEvent"
				v-on:on-drag-event="setRowSelected"
				v-on:on-drop-event="sortableRows"
				class="no-selectable-table no-search-table table-custom-options table-housemaid-assign">
				<template slot="rows" scope="props">
					<td>{{ props.row.number }}</td>
					<td>{{ props.row.roomtype_name }}</td>
					<td>
						<span class="square-state"
							  :style="`background-color: ${props.row.color_state}`"></span>
						<span>{{props.row.room_state_name}}</span>
					</td>
					<td>{{ props.row.hot_floor_id }}</td>
					<td>
						<v-select
							v-bind:items="items"
							item-text="name"
							item-value="id"
							v-model="props.row.type_clean"
							class="select-housemaid-assign"
							hide-details
							v-on:input="changeTypeCleaning(props.row)"
							single-line
							bottom
						></v-select>
					</td>
					<td>
						<v-text-field
							type="number"
							class="time-standard-input"
							suffix="min"
							min="1"
							step="1"
							v-model.number="props.row.time_standard"
							v-on:keyup="toInt(props.row.time_standard)"
							hide-details>
						</v-text-field>
					</td>
					<td class="text-xs-right pr-2 options-column options-column-housemaids"
						:class="{ 'active': props.row.classActive }">
						<div class="arrow-move">
							<img src="/static/img/move.svg" alt="">
						</div>
						<div class="delete-item">
							<v-icon v-on:click="deleteRow(props.row.id)" class="delete-icon">close</v-icon>
						</div>
					</td>
				</template>
			</table-run>
		</v-flex>
		<v-flex md12 pt-2 text-xs-right>
			<v-btn
				v-bind:disabled="isDisabled"
				class="btn-assign-tasks"
				v-on:click="assignHousemaid">
				Enviar
			</v-btn>
		</v-flex>
	</v-layout>
</template>

<script>
import TableRun from 'table-run';
import helper from '@/shared/helper';
import mixin from '@/shared/mixins';
import ListDetailDescription from '@/components/shared/ListDetailDescription';
import UserSelector from '@/components/shared/UserSelector';

const helperMethods = helper.methods;

function beforeRouteEnter(from, to, next) {
	if (helper.methods.getHousemaidAssign()) {
		return next();
	}
	return next({ name: 'housemaids-list' });
}

async function changeTypeCleaning(item) {
	const response = await this.$http.get(`setting/${item.type_clean}/${item.hot_ms_roomtype_id}/time`);
	this.rows = this.rows.map((row) => {
		const newRow = Object.assign({}, row);
		if (item.id === row.id) {
			if (response.data.time) {
				newRow.time_standard = response.data.time;
			} else {
				newRow.time_standard = 1;
			}
		}
		return newRow;
	});
}

function columnSortableEvent({ id }) {
	setTimeout(() => {
		let newData = [];
		const newColumn = this.columns.filter(column => column.id === id);
		newColumn[0].isSortable = newColumn[0].isSortable.down ?
			{ down: false, up: true } : { down: true, up: false };
		const columnName = newColumn[0].code;
		if (newColumn[0].isSortable.up) {
			newData = this.rows.sort((a, b) => {
				if (typeof a[columnName] === 'number' && typeof b[columnName] === 'number') {
					return a[columnName] - b[columnName];
				}
				return a[columnName].charCodeAt() - b[columnName].charCodeAt();
			});
		} else {
			newData = this.rows.sort((a, b) => {
				if (typeof a[columnName] === 'number' && typeof b[columnName] === 'number') {
					return b[columnName] - a[columnName];
				}
				return b[columnName].charCodeAt() - a[columnName].charCodeAt();
			});
		}
		this.rows = newData;
	}, 300);
}

function created() {
	this.loadData();
}

function deleteRow(id) {
	const index = this.rows.findIndex(row => row.id === id);
	if (index >= 0) {
		this.rows.splice(index, 1);
	}
}

function destroyed() {
	helperMethods.removeHousemaidAssign();
}

async function loadData() {
	const response = helperMethods.getHousemaidAssign();
	const request = [];
	response.selectedHousemaid.room_assigned = response.rooms.length;
	response.selectedHousemaid.isOnlyRead = true;
	this.details = [
		{
			description: response.filterDate,
			icon: 'date',
			label: 'Fecha de creación',
		},
		{
			description: new Date().toLocaleTimeString(),
			icon: 'time-done',
			label: 'Hora asignada',
		},
		{
			description: `${response.currentSupervisor.name} ${response.currentSupervisor.lastname}`,
			icon: 'supervisor',
			label: 'Supervisora',
		},
	];
	this.housemaid = response.selectedHousemaid;
	this.supervisor = response.currentSupervisor;
	this.date = response.filterDate;
	const typeCleaningResponse = await this.$http.get('setting-simple-list');
	this.items = typeCleaningResponse.data;
	response.rooms.forEach((room) => {
		request.push(this.$http.get(`setting/${typeCleaningResponse.data[0].id}/${room.hot_ms_roomtype_id}/time`));
	});
	const responses = await Promise.all(request);
	this.rows = response.rooms.map((room, roomIndex) => {
		const newRoom = Object.assign({}, room);
		typeCleaningResponse.data.forEach((typeClean, typeCleanIndex) => {
			if (typeCleanIndex === 0) {
				if (responses[roomIndex].data.time) {
					newRoom.time_standard = responses[roomIndex].data.time;
				} else {
					newRoom.time_standard = 1;
				}
			}
		});
		newRoom.type_clean = typeCleaningResponse.data[0].id;
		return newRoom;
	});
}

function setRowSelected(item) {
	const index = this.rows.findIndex(row => row.id === item.id);
	this.rowIsDraggable = item;
	this.indexRow = index;
}

function sortableRows(item) {
	const index = this.rows.findIndex(row => row.id === item.id);
	this.rows.splice(index, 0, this.rows.splice(this.indexRow, 1)[0]);
}

function toInt(value) {
	const newValue = value.toString();
	if (!value) {
		this.showNotification('El valor para tiempo estándar debe ser un número válido', 'error');
		this.isDisabled = true;
	} else if (value <= 0) {
		this.showNotification('El mínimo valor requerido es 1', 'error');
		this.isDisabled = true;
	} else if (newValue && newValue !== '' && newValue.indexOf('.') > -1) {
		this.showNotification('El valor para tiempo estándar debe ser un número entero', 'error');
		this.isDisabled = true;
	} else {
		this.isDisabled = false;
	}
}

async function assignHousemaid() {
	const assignUrl = 'housekeeping';
	const promises = this.rows.map((row, rowIndex) => {
		const newRow = Object.assign({}, row);
		newRow.order = rowIndex + 1;
		const model = {
			com_companies_id: helperMethods.getUser().company_id,
			com_employee_id: this.housemaid.id,
			com_subsidiaries_id: row.com_subsidiary_id,
			hot_room_id: row.id,
			com_ms_type_cleaning_id: row.type_clean,
			supervisor_id: this.supervisor.id,
			hot_ms_statehk_id: 1,
			date_clear: this.date,
			duration_time_clear: null,
			duration_time_break: null,
			duration_time_bat: null,
			duration_standard: row.time_standard,
			observation: {
				detail: null,
			},
			order: newRow.order,
			tasks: null,
		};
		return this.$http.post(assignUrl, model);
	});
	await Promise.all(promises);
	this.showNotification('Se asignaron correctamente las habitaciones', 'success');
	this.$router.push({ name: 'housemaids-list' });
}

export default {
	beforeRouteEnter,
	components: {
		ListDetailDescription,
		TableRun,
		UserSelector,
	},
	created,
	data() {
		return {
			columns: [
				{ id: 1, name: '# Habitación', code: 'number', isSortable: { down: true, up: false } },
				{ id: 2, name: 'Tipo', code: 'hot_ms_roomtype_id', isSortable: { down: true, up: false } },
				{ id: 3, name: 'Estado', code: 'state', isSortable: { down: true, up: false } },
				{ id: 4, name: 'Piso', code: 'hot_floor_id', isSortable: { down: true, up: false } },
				{ id: 5, name: 'Tipo de limpieza', code: 'type_clean', isSortable: { down: true, up: false } },
				{ id: 6, name: 'Tiempo estándar', code: 'standard_time', isSortable: { down: true, up: false } },
			],
			date: null,
			helperMethods: null,
			housemaid: null,
			indexRow: null,
			items: [],
			rows: [],
			rowIsDraggable: null,
			supervisor: null,
			details: null,
			isDisabled: false,
		};
	},
	destroyed,
	methods: {
		assignHousemaid,
		changeTypeCleaning,
		columnSortableEvent,
		deleteRow,
		loadData,
		setRowSelected,
		sortableRows,
		toInt,
	},
	mixins: mixin,
	name: 'housemaids-assign',
};
</script>

<style lang="scss" scoped>
	.assign-box {
		background-color: white;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, .18);
		margin: auto !important;
		max-width: 90%;
	}

	.options-column {
		display: none;
		
		&.options-column-housemaids {
			display: flex !important;
			justify-content: space-around;

			span {
				display: inline-flex;
			}

			.arrow-move {
				cursor: pointer;
				height: 15px;
				margin-right: 10px;
			}

			img {
				height: 15px;
			}
		}
	}

	.delete-item {
		background-color: map-get($colors, delete-item);
		border-radius: 50%;
		color: white;
		cursor: pointer;
		height: 15px;
		line-height: 1;
		text-align: center;
		width: 15px;
	}

	.delete-icon {
		color: white !important;
		font-size: 13px !important;
		font-weight: bold;
		height: auto !important;
		padding-left: .5px;
		padding-top: 1px;
	}

	.square-state {
		border-radius: 2px;
		display: inline-block;
		height: 8px;
		margin-right: 4px;
		vertical-align: middle;
		width: 9px;

		& + span {
			vertical-align: middle;
		}
	}
</style>




// WEBPACK FOOTER //
// Assign.vue?44914e55